import { sortBy } from 'lodash/fp';

import { COUNTRIES, CountryCode } from 'lib/constants/locales';

export const REPORT_TEMPLATE_COUNTRY_CODE_OPTIONS = sortBy(
  'label',
  Object.keys(COUNTRIES).map((countryCode) => {
    return {
      value: countryCode,
      label: COUNTRIES[countryCode as CountryCode],
    };
  }),
);
